import type { SVGProps } from "react";

export const Firecrawl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    viewBox="0 0 26 28"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Firecrawl</title>
    <text fill="currentColor" fontSize="20" textAnchor="middle" x="13" y="20">
      🔥
    </text>
  </svg>
);

export default Firecrawl;
